<div class="component-container heating-connection-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <app-section-header
      [title]="'technician-data.heating-connection-title' | translate"
      [tooltip]="'tooltips.technician-form.heating-connection' | translate"
      [showTooltip]="infoBubblesData?.showHeatingSupplyInfo"></app-section-header>
  </div>

  <form [formGroup]="heatingConnectionFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
    <div class="form-background">
      <div class="ui-g form-rows">
        <div class="ui-g-6 field-rows" *ngIf="heatingConnectionFG.get('heatingLoad')">
          <label
            for="heating-connection-heating-load"
            class="ui-g-5 field-label text-right-align"
            [class.required]="isFieldRequired('heatingLoad')">
            {{
              (showConnectedLoadLabel ? 'technician-data.form-fields.connected-load' : 'technician-data.form-fields.heating-load')
                | translate
            }}
          </label>
          <input
            [appNumber]="true"
            class="ui-input pInputText small-width"
            formControlName="heatingLoad"
            [readonly]="isReadOnly"
            id="heating-connection-heating-load"
            maxlength="5"
            pInputText
            size="30" />
          <span class="field-unit-label">{{ unitLabels.power }}</span>
        </div>
        <div class="ui-g-6 field-rows" *ngIf="heatingConnectionFG.get('peakFlow')">
          <label for="heating-connection-peak-flow" class="ui-g-5 field-label text-right-align required">
            {{ 'technician-data.form-fields.peak-flow' | translate }}
          </label>
          <input
            [appNumber]="true"
            class="ui-input pInputText small-width"
            formControlName="peakFlow"
            [readonly]="isReadOnly"
            id="heating-connection-peak-flow"
            maxlength="5"
            pInputText
            size="30" />
          <span class="field-unit-label">{{ unitLabels.power }}</span>
        </div>
        <div class="ui-g-6 field-rows padding-left-1" *ngIf="showInfoForCommodities">
          <span [innerHTML]="'technician-data.standard-heating-warning' | translate"></span>
        </div>
      </div>

      <div class="ui-g form-rows" *ngIf="heatingConnectionFG.get('supplyType')">
        <div class="ui-g-6 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="heating-connection-supply-type">
            {{ 'technician-data.form-fields.supply-type' | translate }}
          </label>
          <p-dropdown
            [options]="supplyTypes"
            [readonly]="isReadOnly"
            formControlName="supplyType"
            id="heating-connection-supply-type"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">{{ 'lookup.' + supplyTypeKey + '.options.' + item['value'] + '.name' | translate }}</span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">{{ 'lookup.' + supplyTypeKey + '.options.' + option['value'] + '.name' | translate }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>

      <div class="ui-g form-rows" *ngIf="heatingConnectionFG.get('heatingSystemType')">
        <div class="ui-g-6 field-rows">
          <label class="ui-g-5 field-label text-right-align required" for="heating-connection-system-type">
            {{ 'technician-data.form-fields.heating-system-type' | translate }}
          </label>
          <p-dropdown
            [options]="heatingSystemTypes"
            [readonly]="isReadOnly"
            formControlName="heatingSystemType"
            id="heating-connection-system-type"
            placeholder="-Select-">
            <ng-template let-item pTemplate="selectedItem">
              <span class="drop-item-label">
                {{ 'lookup.' + heatingSystemTypeKey + '.options.' + item['value'] + '.name' | translate }}
              </span>
            </ng-template>
            <ng-template let-option pTemplate="item">
              <div class="drop-item">
                <span class="drop-item-label">
                  {{ 'lookup.' + heatingSystemTypeKey + '.options.' + option['value'] + '.name' | translate }}
                </span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>

      <div class="ui-g form-rows" *ngIf="heatingConnectionFG.get('dhwheating')">
        <div class="ui-g-6 field-rows">
          <label class="ui-g-5"></label>
          <p-checkbox
            binary="true"
            [readonly]="isReadOnly"
            class="checkbox-field"
            formControlName="dhwheating"
            id="heating-connection-dhw-heating"
            label="{{ 'technician-data.form-fields.dhw-heating-checkbox' | translate }}"></p-checkbox>
        </div>
      </div>

      <div *ngIf="currentFormType.index < 2 && heatingConnectionFG.get('compactStation')" class="ui-g form-rows mr-1">
        <div class="ui-g-12 field-rows">
          <label class="ui-g-3"></label>
          <p-checkbox
            binary="true"
            [readonly]="isReadOnly"
            class="checkbox-field left-padding"
            formControlName="compactStation"
            id="heating-connection-compact-station"
            label="{{
              showCompactStationNewLabel
                ? ('technician-data.form-fields.single-bill-checkbox' | translate)
                : ('technician-data.form-fields.compact-station-checkbox' | translate)
            }}"></p-checkbox>
        </div>
      </div>

      <div *ngIf="currentFormType.index > 0 && heatingConnectionFG.get('singleBillCheckbox')" class="ui-g-12">
        <div class="ui-g form-rows">
          <div class="ui-g-12 field-rows">
            <label class="ui-g-3"></label>
            <p-checkbox
              binary="true"
              [readonly]="isReadOnly"
              class="checkbox-field left-padding"
              formControlName="singleBillCheckbox"
              id="single-bill-checkbox"
              label="{{ 'technician-data.form-fields.single-bill-checkbox' | translate }}"></p-checkbox>
          </div>
        </div>

        <div class="ui-g form-rows" *ngIf="heatingConnectionFG.get('typeOf')">
          <div class="ui-g-6 field-rows">
            <label class="ui-g-5 field-label text-right-align" for="type-of">{{ 'technician-data.form-fields.type-of' | translate }}</label>
            <p-dropdown [options]="typeOfValues" formControlName="typeOf" id="type-of" placeholder="-Select-" [readonly]="isReadOnly">
              <ng-template let-item pTemplate="selectedItem">
                <span class="drop-item-label">{{ 'lookup.' + typeOfKey + '.options.' + item['value'] + '.name' | translate }}</span>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="drop-item">
                  <span class="drop-item-label">{{ 'lookup.' + typeOfKey + '.options.' + option['value'] + '.name' | translate }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>

        <div class="ui-g form-rows" *ngIf="heatingConnectionFG.get('variableCostsShare')">
          <div class="ui-g-6 field-rows">
            <label class="ui-g-5 field-label text-right-align" for="variable-costs-share">
              {{ 'technician-data.form-fields.variable-costs-share' | translate }}
            </label>
            <p-dropdown
              [options]="costShareTypes"
              formControlName="variableCostsShare"
              id="variable-costs-share"
              placeholder="-Select-"
              [readonly]="isReadOnly">
              <ng-template let-item pTemplate="selectedItem">
                <span class="drop-item-label">{{ 'lookup.' + costShareTypeKey + '.options.' + item['value'] + '.name' | translate }}</span>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="drop-item">
                  <span class="drop-item-label">
                    {{ 'lookup.' + costShareTypeKey + '.options.' + option['value'] + '.name' | translate }}
                  </span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>

        <div class="ui-g form-rows" *ngIf="heatingConnectionFG.get('smokeAlarmServiceCheckbox')">
          <div class="ui-g-12 field-rows">
            <label class="ui-g-3"></label>
            <p-checkbox
              binary="true"
              [readonly]="isReadOnly"
              class="checkbox-field left-padding"
              formControlName="smokeAlarmServiceCheckbox"
              id="smoke-alarm-service-checkbox"
              label="{{ 'technician-data.form-fields.smoke-alarm-service-checkbox' | translate }}"></p-checkbox>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
